import { PLATFORM_ROUTES } from '@frontend/routing';
import {
  Navigate,
  Outlet,
  useLocation,
  useMatch,
  useSearchParams,
  matchPath,
} from 'react-router-dom';
import useAuth from '../AuthContext/useAuth';
import PlatformHelmet from '../PlatformHelmet/PlatformHelmet';

const PublicRoute = () => {
  const {
    currentUser,
    isCurrentUserBuyer,
    isCurrentUserSeller,
    isCurrentOperationModeBuyer,
  } = useAuth();
  const location = useLocation();
  const matchesEmailVerificationPath = useMatch(
    PLATFORM_ROUTES.emailVerification,
  );
  const [searchParams] = useSearchParams();
  const redirectUrl: string = searchParams.get('redirectUrl') ?? '';
  const accessingFromSellerSignUp =
    new URLSearchParams(location.search).get('user') === 'seller';
  const accessingFromBuyerSignUp =
    new URLSearchParams(location.search).get('user') === 'buyer';

  const getSafeRedirectionUrl = () => {
    let safeRedirectUrl = redirectUrl;
    if (
      !isCurrentUserBuyer &&
      matchPath(PLATFORM_ROUTES.buyerDashboardAll, safeRedirectUrl)
    ) {
      safeRedirectUrl = PLATFORM_ROUTES.sellerDashboard;
    }
    if (
      !isCurrentUserSeller &&
      matchPath(PLATFORM_ROUTES.sellerDashboardAll, safeRedirectUrl)
    ) {
      safeRedirectUrl = PLATFORM_ROUTES.buyerDashboard;
    }
    return safeRedirectUrl;
  };

  const isRoleUpgradeNeeded = () => {
    if (matchPath(PLATFORM_ROUTES.signUp, location.pathname)) {
      return (
        (accessingFromSellerSignUp && !isCurrentUserSeller) ||
        (accessingFromBuyerSignUp && !isCurrentUserBuyer)
      );
    } else {
      return false;
    }
  };

  const getPathFromRoleAndOperationMode = () => {
    if (isCurrentUserSeller && isCurrentUserBuyer) {
      return (isCurrentOperationModeBuyer || accessingFromBuyerSignUp) &&
        !accessingFromSellerSignUp
        ? PLATFORM_ROUTES.buyerDashboard
        : PLATFORM_ROUTES.sellerDashboard;
    } else {
      return isCurrentUserBuyer
        ? `${PLATFORM_ROUTES.buyerDashboard}${isRoleUpgradeNeeded() ? `?roleUpgradeRequest=true` : ''}`
        : `${PLATFORM_ROUTES.sellerDashboard}${isRoleUpgradeNeeded() ? `?roleUpgradeRequest=true` : ''}`;
    }
  };

  if (currentUser && !matchesEmailVerificationPath) {
    const toPath = redirectUrl
      ? getSafeRedirectionUrl()
      : getPathFromRoleAndOperationMode();
    return <Navigate to={toPath} state={{ from: location }} replace />;
  }

  return (
    <>
      <PlatformHelmet />
      <Outlet />
    </>
  );
};

export default PublicRoute;
